/**
 * Центрарховые — 5 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ЦЕНТРАРХОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'pumpkinseed',
        семейство: 'центрарховые',
        latin: 'Lepomis gibbosus',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.4,
        typicalKg: 0.08,
        typicalLengthM: 0.13,
        depthM: 1,
        depthBandM: 1,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 8, опт: 22, макс: 30 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'ил'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'кузнечик', вес: 0.2 },
        ],
    },
    {
        id: 'largemouth_bass',
        семейство: 'центрарховые',
        latin: 'Micropterus salmoides',
        повадка: 'засадный',
        minKg: 0.3,
        maxKg: 6,
        typicalKg: 1,
        typicalLengthM: 0.4,
        depthM: 2,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 6, опт: 24, макс: 31 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'лягушка', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'spoon', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    {
        id: 'smallmouth_bass',
        семейство: 'центрарховые',
        latin: 'Micropterus dolomieu',
        повадка: 'угонщик',
        minKg: 0.3,
        maxKg: 4,
        typicalKg: 0.8,
        typicalLengthM: 0.35,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 4, опт: 21, макс: 27 },
        течение: 'сильное',
        держится: ['камни', 'бровка', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'jig', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    // ── Северная Америка ──
    {
        id: 'black_crappie',
        семейство: 'центрарховые',
        latin: 'Pomoxis nigromaculatus',
        повадка: 'стайная_бель',
        minKg: 0.08,
        maxKg: 1.3,
        typicalKg: 0.3,
        typicalLengthM: 0.28,
        depthM: 4,
        depthBandM: 3,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 20, макс: 28 },
        течение: 'стоячая',
        держится: ['коряги', 'открытая_вода', 'трава'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'jig', вес: 1 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'wobbler', вес: 0.2 },
        ],
    },
    {
        id: 'bluegill',
        семейство: 'центрарховые',
        latin: 'Lepomis macrochirus',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.4,
        typicalKg: 0.1,
        typicalLengthM: 0.18,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 3, опт: 24, макс: 31 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 8 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'хлеб', вес: 0.4 },
            { чем: 'мотыль', вес: 0.4 },
        ],
    },
];
//# sourceMappingURL=centrarchids.js.map